<template>
    <section id="result-search-page" class="vehicle-stock-list">
        <div class="container full-width">
            <div class="row">
                <div class="search-result-top">
                    <div class="top">
                        <div class="left">
                            <h2>
                                <slot name="title"> SBL Stock</slot>
                            </h2>
                        </div>
                    </div>
                    <div class="bottom space-between" v-if="disableHead !== true">
                        <div class="left">
                            <span class="showing">
                                <strong>Showing</strong>
                                <span>{{ from }}</span>-<span>{{ to }}</span> of <span>{{ total }}</span>
                                results
                            </span>
                            <div class="view-type-selection">
                                <label for="view-grid" :class="viewType === 'grid' ? 'active' : ''">
                                    <input id="view-grid" type="radio" value="grid" v-model="viewType" @change="rowColours"/>
                                    <icon icon=" fa-lg fa-th"></icon>
                                </label>
                                <label for="view-list" :class="viewType === 'list' ? 'active' : ''">
                                    <input id="view-list" type="radio" value="list" v-model="viewType" @change="rowColours"/>
                                    <icon icon=" fa-lg fa-list"></icon>
                                </label>
                            </div>
                            <div v-if="showRepFilter">
                                <user-selector
                                    v-model="userFilter"
                                    class="form-control"
                                    :includeReps="true"
                                    :includeDealers="false"
                                    :includeAdmins="false"
                                    :nullLabel="userListNullLabel ? userListNullLabel : '-'"
                                    @change="onChange"
                                    :filter-by-shared-sales-reps="filterBySharedSalesReps ? true : false"
                                >
                                </user-selector>
                            </div>
                            <div class="select-all">
                                <el-select v-model="makeFilter" @change="onMakeChange">
                                    <el-option :value="null" label="Filter by make"></el-option>
                                    <el-option
                                        v-for="item in makes"
                                        :key="item.make"
                                        :label="item.make"
                                        :value="item.make">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="select-all" v-if="makeFilter">
                                <el-select v-model="modelFilter" :loading="modelsLoading" @change="onChange">
                                    <el-option :value="null" label="Filter by model"></el-option>
                                    <el-option
                                        v-for="item in models"
                                        :key="item.model"
                                        :label="item.model"
                                        :value="item.model">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="select-all">
                                <input id="filter-stockid" ref="filter_stockid" type="text" v-model="search" placeholder="Stock ID / Chassis | Lot #" @keyup="onChange"  title="Search multiple by separating by comma or space"/>
                            </div>
                        </div>
                        <div class="right">
                            <div class="text-right" v-if="$userIsAdmin()">
                                <a v-if="!hideAddNew" href="/vehicle-stock/create" class="btn">Add new vehicle</a>
                                <a :href="csvLink" target="_blank" class="btn">CSV</a>
                                <slot name="right_buttons"><!-- --></slot>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-table">
                    <div class="list-table table-responsive" v-if="viewType === 'list'">
                        <b-table
                                class="list-table"
                                :sort-by.sync="sort_by"
                                :sort-desc.sync="sort_desc"
                                @sort-changed="onChange"
                                :fields="fields"
                                :items="vehicle_stocks"
                                :no-local-sorting="true"
                                show-empty
                                :tbody-tr-class="tbodyTrClass"
                                primary-key="id"
                        >
                            <template v-slot:empty="scope">
                                No data is available...
                            </template>
                            <template v-slot:cell(vehicle)="data">
                                <a :href="$laravelRoute('vehicle-stock.show', data.item.id)">
                                    <img :src="data.item.front_image_url" alt="Front"
                                         v-if="data.item.front_image_url" height="50">
                                </a>
                            </template>
                            <template v-slot:cell(co2_text)="data">
                                <span :class="data.item.co2_text[0] === '-' ? 'text-danger' : 'text-success'">
                                    {{ data.item.co2_text.replace('-', '') }}
                                </span>
                            </template>
                            <template v-slot:cell(stock_id)="data">
                                <template v-if="data.item.stock_id">
                                    {{data.item.stock_id}}
                                </template>
                                <template v-else-if="data.item.sold && data.item.sold.heiwa_stock_id">
                                    {{data.item.sold.heiwa_stock_id}}
                                </template>
                                <template v-else>
                                    {{data.item.green_tree_sync_id}}
                                </template>
                            </template>
                            <template v-slot:cell(actions)="data">
                                <a :href="$laravelRoute('vehicle-stock.edit', data.item.id)">Edit</a> |
                                <a :href="$laravelRoute('vehicle-stock.show', data.item.id)">View</a>
                            </template>
                        </b-table>
                    </div>
                    <div class="container-results" id="container-results" v-else>
                        <div v-if="vehicle_stocks.length === 0">
                            No vehicles
                        </div>
                        <template v-for="vehicle of vehicle_stocks">
                            <div class="single-result-search is-vehicle">
                                <div class="container-single-result-search"
                                    @click="selectVehicle(vehicle, $event)">
                                    <div v-if="vehicle.buy_now" class="vehicle-banner now-sold">Now Sold</div>
                                    <div class="stockid">
                                        <span class="checkbox" v-if="enableSelection">
                                            <input type="checkbox" :id="'select-vehicle-'+vehicle.id"
                                                   v-model="selected_ids" :value="vehicle.id"/>

                                            <label :for="'select-vehicle-'+vehicle.id" @click.stop.prevent="selectVehicle(vehicle, $event)"></label>
                                        </span>
                                        <template v-if="vehicle.stock_id">
                                            {{vehicle.stock_id}}
                                        </template>
                                        <template v-else-if="vehicle.sold && vehicle.sold.heiwa_stock_id">
                                            {{vehicle.sold.heiwa_stock_id}}
                                        </template>
                                        <template v-else>
                                            {{vehicle.green_tree_sync_id}}
                                        </template>
                                        <div class="vehicle-hover-images" v-if="showQuickImages">
                                            <vehicle-hover-images :vehicle="vehicle" :letters_only="true"></vehicle-hover-images>
                                        </div>

                                        <div class="unsold-info" v-if="$userIsAdmin()">
                                            <el-tooltip
                                                v-if="(vehicle.is_unsold && vehicle.public_date) || getter === 'global'"
                                                placement="top-start"
                                                effect="light"
                                                :content="publicDateToolTip(vehicle)">
                                                <b-badge pill :variant="vehicle.user_region_price || getter === 'global' ? 'light' : 'danger'">
                                                    {{daysUntil(vehicle)}}
                                                </b-badge>
                                            </el-tooltip>
                                            <el-popover
                                                v-if="vehicle.is_unsold || getter === 'global'"
                                                placement="top-start"
                                                title="Rep Note"
                                                width="200"
                                                trigger="hover"
                                                :disabled="!vehicle.rep_note"
                                                :content="vehicle.rep_note">
                                                <i slot="reference" class="note-icon fa fa-fw fa-lg" :class="{
                                                    'fa-file-text-o': vehicle.rep_note,
                                                    'fa-file-o': !vehicle.rep_note
                                                }" @click.prevent.stop="openRepNoteModel(vehicle)"></i>
                                            </el-popover>
                                        </div>
                                    </div>
                                    <div class="image-vehicle">
                                        <a :href="getVehicleLink(vehicle.id)" @click.prevent="goToCar(vehicle)">
                                            <img :src="vehicle.front_image_url" alt="Front"
                                                 v-if="vehicle.front_image_url">
                                        </a>
                                    </div>
                                    <div class="model">
                                        <a :href="getVehicleLink(vehicle.id)" @click.prevent="goToCar(vehicle)">
                                            {{ vehicle.year }} {{ vehicle.make }}<br>
                                            <span v-html="vehicle.model"></span> /
                                            <span v-html="vehicle.grade"></span>
                                        </a>
                                    </div>
                                    <div v-if="!hidePrices && priceField(vehicle)" class="price-container">
                                        {{priceField(vehicle)}}
                                    </div>
                                    <div class="info">
                                        <div class="infos">
                                            <div>
                                                <span>Grade:</span>
                                                <span class="rating">{{ vehicle.condition }}</span>
                                            </div>
                                            <div class="cc">
                                                <span class="cc">{{ vehicle.engine_capacity }}cc</span>
                                            </div>
                                            <div>
                                                <span class="mileage">{{ vehicle.mileage }}km</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="details">
                                        {{vehicle.transmission}} / {{convertEquipment(vehicle.equipment)}}
                                    </div>
                                    <div class="notes text-success"  v-html="vehicle.sales_note"></div>

                                    <div class="view-more">
                                        <a class="link arrow" :href="getVehicleLink(vehicle.id)" @click.prevent="goToCar(vehicle)">View more</a>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div  class="single-result-search none" v-for="vehicle of [1,2,3,4,5,6,7,8]"></div>
                    </div>
                </div>
                <div class="bottom-container-result d-flex justify-content-end flex-wrap">
                    <div class="d-flex justify-content-end">
                        <b-pagination
                                v-if="total > per_page"
                                :total-rows="total"
                                v-model="current_page"
                                :per-page="per_page"
                        ></b-pagination>
                    </div>
                </div>
            </div>
        </div>
        <vehicle-stock-message ref="vehicleStockMessage" @changed="onVehicleStockMessagesAdd"/>
        <vehicle-stock-rep-note v-model="repNoteModalOpen" :vehicle="repNoteVehicle" @vehicleUpdated=""/>
    </section>
</template>
<script>
    import { mapState, mapActions } from 'vuex'
    import {objLookup, numberWithCommas, objToUrl, setBackToAll, addToUrlQuery} from '../../util/common'
    import vehicleStockMessage from './VehicleStockMessage'
    import UserSelector from '../Common/UserSelector'
    import VehicleStockRepNote from "./VehicleStockRepNote";
    import VehicleHoverImages from '../Common/VehicleHoverImages'
    import _ from 'underscore'

    export default {
        props: [
            'userListNullLabel',
            'showRepFilter',
            'showQuickImages',
            'filterBySharedSalesReps',
            'hidePrices',
            'hideAddNew',
            'sortByProp',
            'sortByDescProp',
            'viewTypeProp',
            'filterByUserRegion',
            'getter',
            'tableFields',
            'tableTrClass',
            'enableSelection',
            'disableHead'
        ],
        components: {
            'vehicle-stock-message': vehicleStockMessage,
            'user-selector': UserSelector,
            'vehicle-stock-rep-note': VehicleStockRepNote,
            'vehicle-hover-images': VehicleHoverImages,
        },
        created(){
            this.fillSearchFields()
            if (this.tableFields) {
                this.fields = this.tableFields;
                console.log('setting table fileds')
            }
            if (this.tableTrClass) {
                this.tbodyTrClass = this.tableTrClass;
            }
            this.getData().then(() => {
                const favs = []
                this.vehicle_stocks.forEach(vehicle => {
                    if (vehicle.is_favourite) {
                        favs.push(vehicle)
                    }
                })
                if (favs && favs.length) {
                    this.$store.commit('vehicleStockFavourites/setFavouritesIds', favs)
                }
            });



            this.$store.dispatch('stock_nextprev/checkStack');
            this.$store.dispatch('stock_nextprev/checkListReturn', this.$route.query.state_key || null)
            this.$store.dispatch('vehicleStock/getMakes');
            window.addEventListener('resize', this.matchHeight)
        },
        mounted() {
            if (this.$refs.filter_stockid) {
                this.$refs.filter_stockid.focus();
            }
        },
        destroyed() {
            window.removeEventListener('resize', this.matchHeight)
        },
        data() {
            return {
                selected_ids: [],
                sort_by: 'sold_date',
                sort_desc: 1,
                repNoteVehicle: null,
                tbodyTrClass: '',
                makeFilter: null,
                modelFilter: null,
                selected_search: null,
                favListModalOpen: false,
                repNoteModalOpen: false,
                vehicle_id: null,
                userFilter: null,
                modelsLoading: false,
                search: null,
                viewType: 'grid',
                users: [],
                stockType: 'all',
                fields: [
                    {label: 'Purchased', key: 'sold_date',sortable: true},
                    {label: 'Vehicle', key: 'vehicle'},
                    {label: 'Make', key: 'make',sortable: true},
                    {label: 'Model', key: 'model', sortable: true},
                    {label: 'Year', key: 'year', sortable: true},
                    {label: 'Mileage', key: 'mileage', sortable: true, formatter: (value) =>{ return numberWithCommas(value, 9999)}},
                    {label: 'Colour', key: 'color', sortable: true},
                    {label: 'Chassis', key: 'chassis', sortable: true},
                    this.$userIsAdmin() ? {label: 'CO2 (indication only)', key: 'co2_text', sortable: true} : null,
                    {label: 'Stock No', key: 'stock_id', sortable: true},
                    {label: 'Reference', key: 'reference',sortable: true},
                    {label: 'Price', key: 'sold_price',sortable: true, formatter: (value) =>{
                        if (this.hidePrices) {
                            return '';
                        }
                        return numberWithCommas(value, 9999)}
                    },
                    {label: 'ETA', key: 'estimated_arrival_date',sortable: true},
                    {label: 'ETD', key: 'estimated_departure_date',sortable: true},
                    {label: 'Actions', key: 'actions'},
                ],
                dataRetrievalCancelTokenSource: null,
            }
        },
        computed: {
            ...mapState({
                vehicle_stocks: state => state.vehicleStock.all,
                per_page: state => state.vehicleStock.per_page,
                from: state => state.vehicleStock.from,
                to: state => state.vehicleStock.to,
                last_page: state => state.vehicleStock.last_page,
                total: state => state.vehicleStock.total,
                makes: state => state.vehicleStock.makes,
                models: state => state.vehicleStock.models,
            }),
            current_page: {
                get(){
                    return this.$store.getters['vehicleStock/get'];
                },
                set(value){
                    return this.getData(value)
                    // let data = {page: value, filter_by_user_region: this.filterByUserRegion}
                    // if (this.$route.query.user_id) {
                    //     data.user_id = this.$route.query.user_id
                    // }
                    // return this.$store.dispatch('vehicleStock/get', data);
                }
            },
            csvLink(){
                let url_path = this.$route.path
                let query = this.$route.query
                query.format = 'csv'
                let url = url_path + '?' + objToUrl(query)
                return url
            },
        },
        methods: {
            ...mapActions({
                isFavourite: 'vehicleStockFavourites/isFavourite',
                addToNextPrevStack: 'stock_nextprev/addToStack',
            }),
            numberWithCommas,
            async onMakeChange(){
                this.modelFilter = null
                this.getData(1)
                this.replaceState()
                await this.loadModels()
            },
            openRepNoteModel(vehicle){
                this.repNoteModalOpen = true;
                this.repNoteVehicle = vehicle;
            },
            async loadModels(){
                this.modelsLoading = true;
                await this.$store.dispatch('vehicleStock/getModels', this.makeFilter);
                this.modelsLoading = false;
            },
            onTagChanged(data){
                let selected = this.selectedVehicles.indexOf(data.vehicle_id);
                if (data.removed) {
                    if (data.tags_left === 0 && selected !== -1) {
                        this.selectedVehicles.splice(selected, 1);
                    }
                } else {
                    if (selected === -1) {
                        this.selectedVehicles.push(data.vehicle_id);
                    }
                }
            },
            fillSearchFields(){
                if (this.sortByProp) {
                    this.sort_by = this.sortByProp
                }
                if (this.viewTypeProp) {
                    this.viewType = this.viewTypeProp
                }
                if (this.sortByDescProp !== undefined) {
                    this.sort_desc = this.sortByDescProp
                }
                if (this.$route.query.user_id) {
                    this.userFilter = parseInt(this.$route.query.user_id)
                    this.stockType = 'filter-user'
                }
                if(this.$route.query.make) {
                    this.makeFilter = this.$route.query.make
                    this.loadModels()
                }
                if(this.$route.query.view_type) {
                    this.viewType = this.$route.query.view_type
                }
                if(this.$route.query.model) {
                    this.modelFilter = this.$route.query.model
                }
                if(this.$route.query.search) {
                    this.search = this.$route.query.search
                }
            },
            replaceState(){
                let args = {}
                if (this.makeFilter) {
                    args.make = this.makeFilter
                }
                if (this.modelFilter) {
                    args.model = this.modelFilter
                }
                if (this.search) {
                    args.search = this.search
                }
                if (this.userFilter) {
                    args.user_id = this.userFilter
                }
                let query = objToUrl(args)
                let url = this.$route.path
                if (query) {
                    url = `${url}?${query}`
                }
                this.$router.replace(url);

            },
            onStockTypeChange(){
                this.userFilter = null
                this.getData(1)
            },
            onChange: _.debounce(function () {
                this.getData(1)
                this.replaceState()
            }, 200),
            getData(page = 1){
                return new Promise((resolve, reject) => {
                    this.$nextTick(async () => {
                        let data = {
                            sort_by: this.sort_by,
                            sort_desc: this.sort_desc ? 1 : 0,
                            filter_by_user_region: this.filterByUserRegion,
                            stock_type: this.stockType,
                            filter_make: this.makeFilter,
                            filter_model: this.modelFilter,
                            search: this.search,
                            page
                        }
                        if (this.userFilter) {
                            data.user_id = this.userFilter
                        }
                        if (this.dataRetrievalCancelTokenSource) {
                            this.dataRetrievalCancelTokenSource.cancel('Request cancelled')
                        }
                        this.dataRetrievalCancelTokenSource = this.axios.CancelToken.source();
                        const res = await this.$store.dispatch(`vehicleStock/get`,
                            {
                                endpoint: this.getter,
                                args: data,
                                cancelToken: this.dataRetrievalCancelTokenSource
                            });
                        resolve(res)
                        const ids = []
                        this.vehicle_stocks.forEach(v => {
                            ids.push(v.id)
                        })
                        this.addToNextPrevStack({ids});
                        this.matchHeight()
                        this.rowColours()
                    });
                })
            },
            matchHeight(){
                const matchHeightFunc = selector => {
                    let maxHeight = 0;
                    let models = document.querySelectorAll(selector);
                    models.forEach(model => {
                        model.style.height = '';
                        if (model.clientHeight > maxHeight) {
                            maxHeight = model.clientHeight;
                        }
                    });
                    models.forEach(model => {
                        model.style.height = maxHeight + 'px';
                    })
                }
                this.$nextTick(() => {
                    matchHeightFunc('.sale_tag_wrapper')
                    matchHeightFunc('.model')
                    matchHeightFunc('.infos')
                    matchHeightFunc('.details')
                    matchHeightFunc('.notes')
                })
            },
            rowColours(){
                this.$nextTick(() => {
                    let rows = document.querySelectorAll('.list-table tbody tr');
                    if (rows.length) {
                        rows.forEach(row => {
                            row.classList.forEach(className => {
                                if (className.includes('row-colour')) {
                                    const rowColour = className.replace('row-colour-', '');
                                    row.style.backgroundColor = rowColour;
                                }
                            })
                        })
                    }
                })
            },
            objLookup(obj, key){
                return objLookup(obj, key);
            },
            deleteVehicleStock (vehicleStockId) {
                this.$store.dispatch('vehicleStock/deleteVehicleStock', {
                    id: vehicleStockId,
                }).then(vehicle_stocks => {
                    return this.getData(value)
                });
            },
            displayAuctionHouse(orig_name) {
                let auctionName = '';
                if (orig_name) {
                    let name = orig_name.replace(/[^a-zA-Z]/, ' ').replace(/\s{2,}/, ' ');
                    // Auction name split in an array
                    if (name.indexOf(' ') !== -1) {
                        let arrayName = name.split(' ');
                        // Compose the auction name 2 chars for the first word and 3 chars for the second word.
                        auctionName = arrayName[0].slice(0, 2) + '-' + arrayName[1].slice(0, 3)
                    } else if (name.length > 2) {
                        auctionName = name.slice(0, 2);
                    }
                }
                return auctionName;
            },
            getVehicleLink(id) {
                let url = this.$laravelRoute('vehicle-stock.show', id, false);
                if (window.history && window.history.state && window.history.state.key) {
                    url = addToUrlQuery(url, {state_key: window.history.state.key})
                }
                return url;
            },

            goToCar(vehicle) {
                console.log('goToCar')
                let url = this.getVehicleLink(vehicle.id)
                if (window.history && window.history.state && window.history.state.key) {
                    console.log('leaving')
                    this.$store.dispatch('stock_nextprev/leavingListPage')
                }
                this.$router.push(url);
            },
            priceField(v){
                let price = false
                if (this.tableFields) {
                    this.tableFields.forEach(field => {
                        if (field && field.key === 'price') {
                            price = field.formatter(null, field.key, v)
                        }
                    })
                }
                return price
            },
            daysUntil(vehicle){
                const now = window.moment()
                if (this.getter === 'global') {
                    if (vehicle.global_list_date) {
                        const days = window.moment(now).diff(vehicle.global_list_date, 'days')
                        return days;
                    }
                } else{
                    if (vehicle.public_date) {
                        const days = window.moment(vehicle.public_date).diff(now, 'days')
                        return days + 1;
                    }
                }
                return ''
            },
            convertEquipment(item) {
                if(item) {
                    let html = item.replace(/ /g, ', ');
                    html = html.replace(/,{1,}/g, ',').toUpperCase();
                    return html;
                }

                return '';
            },
            openMessageModal(vehicleStock, repOnly = false) {
                this.$refs.vehicleStockMessage.openModal(vehicleStock, repOnly);
            },
            onVehicleStockMessagesAdd(vehicleStockId, message) {
                this.$store.commit('vehicleStock/addMessage', {id: vehicleStockId, message: message});
            },
            getDate(data) {
                return window.moment(data).format(this.defaultMomentDateFormat())
            },
            getTime(data) {
                return window.moment(data).format('HH:mm')
            },
            publicDateToolTip(vehicle){
                if (this.getter === 'global') {
                    if (vehicle.global_list_date) {
                        const global_list_date = window.moment(vehicle.global_list_date).format(this.defaultMomentDateFormat())
                        return 'Since ' + global_list_date;
                    }
                    return '';
                }
                const public_date = window.moment(vehicle.public_date).format(this.defaultMomentDateFormat())
                return 'Moves to public stock on ' + public_date + (vehicle.user_region_price ? '' : ' (Admin to set public price, will not move to public stocklist)');
            },
            async selectVehicle(vehicle, e) {
                let selected = this.selected_ids.indexOf(vehicle.id);
                if (selected !== -1) {
                    this.selected_ids.splice(selected, 1);
                } else {
                    this.selected_ids.push(vehicle.id);
                }
                this.$emit('selectVehicle', vehicle, this.selected_ids, e)
            },
        }
    }

</script>

<style lang="scss" scoped>
.vehicle-hover-images{
    margin-left: auto;
    margin-top: -5px;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/VehicleStock/ListPage.vue